export const SORT_DIRECTIONS = {
	NONE: null,
	ASC: 'asc',
	DESC: 'desc'
};
